<template>
	<b-container>
		<b-form @submit.prevent>
			<b-row class="mt-3">
				<b-col>
					<b-link class="float-right ml-3" @click.prevent="updateContact" title="Save section">
						<b-icon font-scale="1.5" icon="check-square" variant="success"></b-icon>
					</b-link>
				</b-col>
			</b-row>

			<b-row class="mt-3">
				<b-col>
					<h1>{{ contact.Name }}</h1>
				</b-col>
			</b-row>

			<b-row class="mt-3">
				<b-col>
					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Name:" for="name">
						<b-col>
							<b-input id="name" v-model="contact.Name" type="text" required />
						</b-col>
					</b-form-group>

					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Position:" for="position">
						<b-col>
							<b-input id="position" v-model="contact.Position" type="text" />
						</b-col>
					</b-form-group>

					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Email:" for="email">
						<b-col>
							<b-input id="email" v-model="contact.EmailAddress" type="email" />
						</b-col>
					</b-form-group>

					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Telephone:" for="telephone">
						<b-col>
							<b-form-input id="telephone" v-model="contact.Telephone" type="text" />
						</b-col>
					</b-form-group>

					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Mobile:" for="mobile">
						<b-col>
							<b-form-input id="mobile" v-model="contact.Mobile" type="text" />
						</b-col>
					</b-form-group>

					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Notes:" for="notes">
						<b-col>
							<b-textarea id="notes" v-model="contact.Description" type="text" />
						</b-col>
					</b-form-group>
				</b-col>

				<b-col>
					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Address 1:" for="address1">
						<b-col>
							<b-input id="address1" v-model="contact.Address.Address1" type="text" />
						</b-col>
					</b-form-group>

					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Address 2:" for="address2">
						<b-col>
							<b-input id="address2" v-model="contact.Address.Address2" type="text" />
						</b-col>
					</b-form-group>

					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Address 3:" for="address3">
						<b-col>
							<b-input id="address3" v-model="contact.Address.Address3" type="text" />
						</b-col>
					</b-form-group>

					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Town:" for="town">
						<b-col>
							<b-input id="town" v-model="contact.Address.Town" type="text" />
						</b-col>
					</b-form-group>

					<b-form-group :label-cols="2" breakpoint="md" horizontal label="County:" for="county">
						<b-col>
							<b-input id="county" v-model="contact.Address.County" type="text" />
						</b-col>
					</b-form-group>

					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Postcode:" for="postcode">
						<b-col>
							<b-input id="postcode" v-model="contact.Address.Postcode" type="text" />
						</b-col>
					</b-form-group>
				</b-col>
			</b-row>

			<b-form-fieldset>
				<legend>Customers</legend>

				<b-table-simple bordered>
					<b-thead head-variant="light">
						<tr>
							<th>Customer</th>
							<th>Notes</th>
						</tr>
					</b-thead>

					<b-tbody>
						<tr v-for="customer in customers" :key="customer.Id">
							<td>
								<b-link href="#" @click.prevent="onCustomerClick(customer.Id)">{{ customer.Name }}</b-link>
							</td>

							<td>{{ customer.Description }}</td>
						</tr>
					</b-tbody>
				</b-table-simple>
			</b-form-fieldset>

			<b-form-fieldset>
				<legend>Clocks</legend>

				<b-table-simple bordered>
					<b-thead head-variant="light">
						<tr>
							<th>Clock</th>
							<th>Notes</th>
							<th style="width: 15%"></th>
						</tr>
					</b-thead>

					<b-tbody>
					
						<tr v-for="(clock, index) in clocks" :key="index + 10">
							<td>
								<b-link href="#" @click.prevent="onClockClick(clock.Id)">{{ clock.Name }}</b-link>
							</td>

							<td>{{ clock.Description }}</td>

							<td class="align-middle">
								

								<b-link class="ml-3 float-right" title="Remove this clock" @click.prevent="removeFromArray('Clocks', index, true)">
									<b-icon font-scale="1.5" icon="dash-square" variant="danger"></b-icon>
								</b-link>
								
							</td>
						</tr>
					</b-tbody>
				</b-table-simple>
			</b-form-fieldset>
		</b-form>

		<confirm ref="confirm"></confirm>
	</b-container>
</template>

<script>
import CustomerService from '@/api-services/customer.service';
import ContactService from '@/api-services/contact.service';
import ClockService from '@/api-services/clock.service';
import Confirm from '@/components/partials/confirm';

export default {
	name: 'ContactUpdate',

	components: {
		Confirm
	},

	data() {
		return {
			contact: {
				Address: {},
				
			},
			clocks: [],
			customers: []
		};
	},

	mounted() {
		this.fetchContact();


	},

	created() {},

	methods: {
		fetchContact() {
			ContactService.get(this.$router.currentRoute.params.id).then((response) => {
				this.contact = response.data;

				if (this.contact.Address == null) {
					this.contact.Address = {};
				}

				
				// populate clocks
				if (this.contact.ClockContacts.length) {

					this.contact.Clocks = [];


					this.contact.ClockContacts.forEach((clockContact, i) => {
						let clockId = clockContact.ClockId;

						ClockService.get(clockId).then((response) => {
							this.clocks.push(response.data);
						});

						
					});
				}

				// populate customers
				if (this.contact.CustomerContacts.length) {
					this.contact.CustomerContacts.forEach((customerContact, i) => {
						let customerId = customerContact.CustomerId;

						CustomerService.get(customerId).then((response) => {
							this.customers.push(response.data);
						});
					});
				}
			});
		},

		updateContact() {

			this.contact.Clocks = this.clocks;

			ContactService.update(this.$router.currentRoute.params.id, this.contact)
				.then(() => {
					this.$refs.confirm.open('Success', 'Successfully updated contact', true)
					.then((confirm) => {
						//this.$router.push({ name: 'contacts' });
					});
				})
				.catch((error) => {
					let modal_options = {
						text: 'light',
						background: 'danger'
					};

					this.$refs.confirm.open('Error', error.response.data, true, modal_options);
				});
		},

		removeFromArray(section, index, hold) {
			if (hold) {
				this.$refs.confirm.open('Confirm action', 'Are you sure you want to remove this item from ' + section).then((confirm) => {
					if (confirm) {
						this.removeFromArray(section, index);
					}
				});
				
			} else {

				this.$delete(this.clocks, index);

				this.updateContact();
			}
		},


		onClockClick(clockId) {
			this.$router.push({
				name: 'clockupdate',
				params: { id: clockId }
			});
		},

		onCustomerClick(customerId) {
			this.$router.push({
				name: 'customerupdate',
				params: { id: customerId }
			});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/contact/contact-update.vue